(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/ticket-gifts/assets/javascripts/prescript.js') >= 0) return;  svs.modules.push('/modules/ticket-gifts/assets/javascripts/prescript.js');
"use strict";

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
const constants = {
  TICKETS_DOMAIN: 'svs.tickets',
  TICKETS_KEY: 'vouchersToPlay',
  reactPayfooterCustomerServiceTexts: [{
    content: 'Behöver du hjälp?',
    classes: 'f-550'
  }, {
    content: 'Kontakta Kundservice. Telefon 0770-11 11 11.'
  }]
};
const getThemeGame = function (games) {
  let skinId = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  const themeGame = games.find(game => {
    var _game$themes;
    return game.isThemeable && ((_game$themes = game.themes) === null || _game$themes === void 0 ? void 0 : _game$themes.find(_ref => {
      let {
        themeName
      } = _ref;
      return themeName.toLowerCase() === skinId;
    }));
  });
  if (themeGame) {
    const themeToUse = themeGame.themes.find(theme => theme.themeName.toLowerCase() === skinId);
    return _objectSpread(_objectSpread({}, themeGame), {}, {
      theme: themeToUse.themeName,
      skins: themeToUse.skins,
      variations: themeToUse.skins.length
    });
  }
  const game = games.find(game => game.theme.toLowerCase() === skinId);
  if (!game) {
    const applicableGames = games === null || games === void 0 ? void 0 : games.map(_ref2 => {
      let {
        type
      } = _ref2;
      return type;
    });
    svs.ticket_gifts.logger.warn("No matching game found for theme ".concat(skinId, " for applicable games: ").concat(applicableGames));
  }
  return game;
};
const chooseGameForVoucher = function () {
  var _voucher$skinId;
  let voucher = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  let enableEqualPrizedGame = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
  const games = svs.ticket_gifts.games;
  const skinId = (_voucher$skinId = voucher.skinId) === null || _voucher$skinId === void 0 ? void 0 : _voucher$skinId.toString().toLowerCase();
  const applicableGames = games.filter(game => Number(game.voucherId) === Number(voucher.voucherConfigId) && game.open).sort((a, b) => (a.claimableAs.indexOf(a.type) + 1 || Infinity) - (b.claimableAs.indexOf(b.type) + 1 || Infinity));
  const themeGame = getThemeGame(applicableGames, skinId);
  const equalPrizeGame = games.find(game => parseInt(voucher.value, 10) === parseInt(game.price, 10) && game.open);
  const game = themeGame || applicableGames[0] || (enableEqualPrizedGame ? equalPrizeGame : undefined);
  if (!game) {
    svs.ticket_gifts.logger.warn('No applicable game found for voucher', JSON.stringify(voucher));
  } else {
    game.normalizeSkinId = skinId => skinId > 0 && skinId <= game.variations ? skinId : 1;
    const msg = "ticket with gameCode ".concat(game.type, " found for voucher with voucherConfigId ").concat(voucher.voucherConfigId, ", themeName ").concat(skinId, " and ticketPosition ").concat(voucher === null || voucher === void 0 ? void 0 : voucher.ticketPosition, " - theme ").concat(game.themeName, " with skinId ").concat(game.normalizeSkinId(voucher === null || voucher === void 0 ? void 0 : voucher.ticketPosition), " shown");
    svs.ticket_gifts.logger.info(msg);
  }
  return game;
};
const functions = {
  bubbleInfoHeader(personalGreeting, name) {
    const greeting = personalGreeting || 'Varsågod';
    return "".concat(greeting).concat(name && " ".concat(name) || '', "!");
  },
  chooseGameForVoucher
};
svs = svs || {};
svs.ticket_gifts = svs.ticket_gifts || {};
svs.ticket_gifts.logger = svs.core.log.getLogger('ticket-gifts');
svs.ticket_gifts.constants = svs.ticket_gifts.constants || constants;
svs.ticket_gifts.functions = svs.ticket_gifts.functions || functions;
svs.ticket_gifts.games = svs.ticket_gifts.data.redeemableTickets;
svs.ticket_gifts.chooseGameForVoucher = chooseGameForVoucher;

 })(window);